import styles from './index.module.scss'
import classNames from 'classnames'
import Icon from 'common/Icon'
import BaseButton from 'common/BaseButton'
import { CINDER } from 'constants/colors'

type ErrorBannerProps = {
  message: string | React.ReactNode
  isRedesign?: boolean
  closeToast?: () => void
  showWarningIcon?: boolean
}

const ErrorBanner: React.FC<ErrorBannerProps> = ({
  message,
  isRedesign,
  closeToast,
  showWarningIcon = false,
}) =>
  isRedesign ? (
    <div className={classNames(styles.error_banner_new, '~font-roboto')}>
      {showWarningIcon && (
        <Icon icon="warning" className={styles.warning_icon} fill={`#D2444A`} />
      )}
      <div className={`${styles.message}`}>{message}</div>
    </div>
  ) : (
    <div
      className={classNames(
        styles.banner_container,
        styles.error_banner,
        '~font-roboto ~flex ~items-center ~justify-between'
      )}
    >
      <div>{message || 'Opps something went wrong.'}</div>
      <BaseButton onClick={closeToast} aria-label="Close">
        <Icon icon="close" fill={CINDER} className="fa-lg" />
      </BaseButton>
    </div>
  )

export default ErrorBanner
